import classNames from 'classnames';
import styles from './promotion-home.style';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { useRef } from 'react';
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import { scrollToTopPage } from 'utils/function';
import { useNavigate } from 'react-router-dom';

interface Props {
    promoList: any[];
}

function PromotionHome(props: Props) {
    const { promoList } = props;
    const btnPrevSlide = useRef<HTMLButtonElement>(null);
    const btnNextSlide = useRef<HTMLButtonElement>(null);
    const navigate = useNavigate();

    const goToPromotionPage = (id: number) => {
        navigate('/promotion/' + id);
        scrollToTopPage();
    };

    return (
        <div className={styles.wrap}>
            <button ref={btnPrevSlide} className={`${styles.btnPrev} ${styles.btnNavigate}`}>
                <GrFormPrevious size={48} />
            </button>
            <button ref={btnNextSlide} className={`${styles.btnNext} ${styles.btnNavigate}`}>
                <GrFormNext size={48} />
            </button>
            <Swiper
                autoplay={{
                    delay: 420333330
                }}
                slidesPerView={3}
                spaceBetween={40}
                centeredSlides={true}
                pagination={{ clickable: true }}
                speed={600}
                loop={promoList.length > 3} // ✅ phải > 3
                modules={[Navigation, Autoplay]}
                navigation={{
                    prevEl: btnPrevSlide.current,
                    nextEl: btnNextSlide.current,
                }}
            >
                {promoList.map((item) => (
                    <SwiperSlide key={item.id}>
                        <div key={item.id} className={classNames(`${styles.item} slide-elm`)}>
                            <div className={classNames(`${styles.itemInner} slide-item`)}>
                                <div className={styles.wrapImg} onClick={() => goToPromotionPage(item.id)}>
                                    {item.photourl && <img src={item.photourl} alt="" />}
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default PromotionHome;
